import React from 'react';
import styles from '../Operations.module.css';

interface OSSCComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

const OSSC: OSSCComponent = () => {
  return (
    <div className={styles.container}>
      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
       Surveys completed by customers in a rolling 12-month time period.
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        Find more information on:{' '}
        <a
          href="https://acenet.aceservices.com/awor/helpful-customer-service/customer-first-culture"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
          Acenet &gt; AWOR &gt; Helpful Experience &gt; Measure Helpful
        </a>
      </div>

      <div className={styles.sectionTitle}>
        Goal
      </div>
      <div className={styles.sectionContent}>
       80
      </div>

         <div className={styles.sectionTitle}>
        Drill Down
      </div>
      <div className={styles.sectionContent}>
       To drill down into data login to the:{' '}
        <a
          href="https://acehardware.medallia.com/sso/acehardware/idpSelect.do"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}>
         Helpful Experience/Medallia Dashboard
        </a>
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        Click here to learn how to increase survey response Key Recommendations for enhanced Customer Experience Survey Response.
        <ul style={{ marginTop: '0.5rem', paddingLeft: '2rem' }}>
          <li>
            Ensure your Eagle system is at L29.0 or latest level to allow for auto updated hotsheet survey information to print on the bottom of your receipt.
            <ul style={{ paddingLeft: '2rem' }}>
              <li>In addition, make sure that Option IDs 8875 and 8876 are turned to Y or Yes at POS to activate the CE program and accept survey hotsheets.</li>
            </ul>
          </li>
          <li>
            Increase survey participation - purchase the Talk to Ace Customer Satisfaction Survey Tear pad on Marketing Muscle.
            <ul style={{ paddingLeft: '2rem' }}>
              <li>Search on SKU: PD – 889500</li>
              <li>$8.00/150 sheet tear pad</li>
            </ul>
          </li>
          <li>
            Purchase the pre-printed receipt paper through the warehouse
            <ul style={{ paddingLeft: '2rem' }}>
              <li>Search on Thermal Warehouse SKU: 9062487 - Epicor</li>
              <li>Search on Bond Warehouse SKU: 9062488 – Epicor</li>
              <li>Search Marketing Muscle SKU: EA-118000 – Paladin</li>
            </ul>
          </li>
          <li>
            Purchase the Customer Experience Survey Poster:
            <ul style={{ paddingLeft: '2rem' }}>
              <li>Search on SKU 114154</li>
              <li>7.50/poster - Size 22&quot; x 23.25</li>
            </ul>
          </li>
        </ul>
        Helpful Tip: Get the cashiers involved in asking customers to take the survey. Tell customers that you are trying to reach a goal. Folks love it when they are part of a goal. “Please take our survey we are trying to reach a goal, and we would love to hear about your experience in our store”. Whether it is circling it on the bottom of the receipt, stapling a tear pad to their receipt or pointing to a poster, get cashiers involved in asking the customer to take the survey. 
      </div>
    </div>
  );
};

OSSC.title = 'Customer Experience Surveys Completed';
OSSC.actionTitle = 'Review Medallia Dashboard';
OSSC.actionHyperlink = 'https://acehardware.medallia.com/sso/acehardware';
export default OSSC;
